// extracted by mini-css-extract-plugin
export default {"wrapper":"contentsLayout_wrapper__HpdAR","headingTitle":"contentsLayout_headingTitle__XoJUg"};